import { Icon } from "@iconify/react"
import React, { useEffect, useState } from "react";
import useStore from "../store/zustandstore";
import AdminMenu from "../components/admin/adminsidemenu";
import "../css/admin.css"
import UploadJobs from "../components/admin/uploadjobs";
import { useNavigate } from "react-router-dom";
import Aitask from "../components/admin/aitask";
import HeadlineReview from "../components/admin/headlinereview";
import usefbStore from "../store/firebasestore";
import AdminLoader from "../components/admin/adminLoader";
import { doc, getDoc, where, query } from "firebase/firestore";
import { collection, getCountFromServer } from "firebase/firestore";
import { auth, db } from "../firebase/firebase"
import AdminDashDrawer from "../components/admin/dashdrawer";
import UserManagement from "../components/admin/usermanagement";
function Admin() {
  const hideScreenLoader = useStore((s) => s.hideScreenLoader);
  const allUsersDrawer = useStore((s)=>s.allUsersDrawer)
  const isAdminDashActive = useStore((s) => s.isAdminDashActive);
  const isAItaskActive = useStore((s) => s.isAItaskActive);
  const navigate = useNavigate();
  const setAdminName = usefbStore((s) => s.setAdminName);
  const authStatus = usefbStore((s) => s.authStatus);
  const setUserID = usefbStore((s) => s.setUserID);
  const removeAdminLoader = useStore((s) => s.removeAdminLoader);
  const isJobUploadActive = useStore((s) => s.isJobUploadActive);
  const setAdminLoader = useStore((s) => s.setAdminLoader);
  const [isAdmin, setIsAdmin] = useState(false);
  const adminLoader = useStore((s) => s.adminLoader);

  async function countDocs() {
    const coll = collection(db, "Ai-tasks");
    
    // Content Review
    const reviewQuery = query(coll, where("type", "==", "Content Review"));
    const reviewSnap = await getCountFromServer(reviewQuery);
    const reviewCount = reviewSnap.data().count;
    
    // Fact Check
    const factQuery = query(coll, where("type", "==", "Fact Check"));
    const factSnap = await getCountFromServer(factQuery);
    const factCount = factSnap.data().count;
    
    // Content Translation
    const translationQuery = query(coll, where("type", "==", "Content Translation"));
    const translationSnap = await getCountFromServer(translationQuery);
    const translationCount = translationSnap.data().count;
    
  }

  countDocs();

  function getGreetings() {
    const hours = new Date().getHours();
    if (hours < 12) return "Good morning,";
    if (hours < 18) return "Good afternoon,";
    return "Good evening,";
  }

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > window.innerHeight) {
        removeAdminLoader();
      } else {
        setAdminLoader();
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (authStatus === "unauthenticated") {
      navigate("/auth");
      return;
    }
    
    // First, update your user document in Firestore to have an admin field
// Go to Firestore -> Users -> t03UjwiWgpXehDKsH7S0X7F5rvD2
// Add field: isAdmin: true

if (authStatus === "authenticated") {
  const unsubscribe = auth.onAuthStateChanged(async (user) => {
    if (!user) return;
    
    // FORCE REFRESH TOKEN - Important!
    await user.getIdToken(true); // true forces refresh
    
    const token = await user.getIdTokenResult();
    
    setUserID(user.uid);
    
    if (token.claims.admin) {
      const userRef = doc(db, "Users", user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        var name = userSnap.data().name;
        setAdminName(name);
        setIsAdmin(true);
        hideScreenLoader();
      }
    } else {
      navigate("/");
    }
  });
  return () => unsubscribe();
}
  }, [authStatus]);

  return (
    <>
      {isAdmin && (
        <div>
          {!adminLoader ? (
            <div className="adminWrap">
              <div className="adminMenuWrap">
                <AdminMenu />
              </div>
              <div className="adminDash">
                <div className="adminDashTop">
                  <span>{getGreetings()}</span>
                  <div className="adminTopMini">
                    <div className="adnotify">
                      <div className="newAlert"></div>
                      <Icon className="faIcon" icon="solar:bell-outline" />
                    </div>
                  </div>
                </div>
                <div className="adminDashDrawer">
                  <div className={`admin-Dash ${isAdminDashActive ? "admin-DashActive" : ""}`}>
                    <AdminDashDrawer />
                  </div>
                  <div className={`admin-AITask ${isAItaskActive ? "admin-AITaskActive" : ""}`}>
                    <Aitask />
                  </div>
                  <div className={`admin-AITask ${isJobUploadActive ? "admin-AITaskActive" : ""}`}>
                    <UploadJobs />
                  </div>
                  <div className={`admin-AITask ${allUsersDrawer ? "admin-AITaskActive" : ""}`}>
                    <UserManagement />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <AdminLoader />
          )}
        </div>
      )}
    </>
  );
}

export default Admin;